export enum AboutMFOTitleEnum {
  Introduction = 'Introduction',
  Security = 'Security',
  TheBasics = 'The Basics',
  Status = 'Status',
}
